import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  private emailUrl = 'localhost:4201/send-email'; // Replace with your backend URL

  constructor(private http: HttpClient) { }

  sendEmail(name: string, email: string, message: string) {
    const data = {
      name: name,
      email: email,
      message: message
    };
    console.log(":::::: "+JSON.stringify(data));
    console.log(":::::: "+this.emailUrl);

    return this.http.get(this.emailUrl);
  }

}
